module.exports = __webpack_public_path__ + "img/computer.ca9322c2.png";